<template>
  <div class="banner-item">
    <div class="banner-item__icon">
      <slot name="icon"></slot>
    </div>
    <div class="banner-item__content">
      <div class="banner-item__header">
        <span class="title">{{ title }}</span>
        <span class="subtitle">{{ subtitle }}</span>
      </div>
      <div class="banner-item__description">{{ description }}</div>
      <div class="banner-item__footer">{{ footer }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bannerItem",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    footer: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.banner-item {
  background: #ffffff;
  border-radius: 10px;
  padding: 32px;
  backdrop-filter: blur(76px);
  box-shadow: 0px 4px 15.9px 0px #386FC614;
}

.banner-item__icon {
  margin-bottom: 32px;
}

.banner-item__icon :deep(svg) {
  width: 36px;
  height: 36px;
}

.banner-item__header {
  display: flex;
  align-items: center;
  margin-bottom: 13px;
}

.title {
  color: #1f2329;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
}

.subtitle {
  color: #4E5969;
  font-size: 18px;
  font-weight: 500;
  margin-left: 16px;
  padding-left: 8px;
  border-left: 1px solid #c9cdd4;
}

.banner-item__description {
  color: #50627f;
  font-size: 16px;
  margin-bottom: 40px;
}

.banner-item__footer {
  color: #1CB3B8;
  font-size: 20px;
  font-weight: 500;
}
</style>
